import {
  ObservableState,
  reducedStream,
  toPersistentStream,
} from '@ardoq/rxbeach';
import { reducers } from './reducers';
import { getDefaultState } from './utils';
import { combineLatest, map, Observable } from 'rxjs';
import {
  AdvancedSearchConditionStreamShape,
  AdvancedSearchConditionViewShape,
} from './types';
import { fields$ } from 'streams/fields/fields$';
import { locale$ } from 'streams/locale$';
import { i18nLocale$ } from 'streams/i18nLocale$';

const advancedSearchConditionByReferenceBase$: Observable<AdvancedSearchConditionStreamShape> =
  reducedStream(
    'advancedSearchConditionByReferenceBase$',
    getDefaultState(),
    reducers
  );

const advancedSearchConditionByReference$: ObservableState<AdvancedSearchConditionStreamShape> =
  toPersistentStream(
    'advancedSearchConditionByReference$',
    combineLatest([
      advancedSearchConditionByReferenceBase$,
      fields$,
      locale$,
    ]).pipe(
      map(([state, fields, locale]) => ({
        ...state,
        fields: fields.models,
        locale,
      }))
    ),
    getDefaultState()
  );

export const advancedSearchConditionByReferenceViewModel$: Observable<AdvancedSearchConditionViewShape> =
  combineLatest([advancedSearchConditionByReference$, i18nLocale$]).pipe(
    map(([state, i18nLocale]) => ({ ...state, i18nLocale }))
  );

export { advancedSearchConditionByReference$ };
